// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.common.enums.PaymentCategory

export enum PaymentCategory {
  MOVE_IN_COSTS = 'MOVE_IN_COSTS',
  ONE_TIME = 'ONE_TIME',
  OTHER = 'OTHER',
  RENT = 'RENT',
  RENTAL_PROTECTION_DIRECT_DEBIT = 'RENTAL_PROTECTION_DIRECT_DEBIT',
}

export const PaymentCategory_values = [
  PaymentCategory.MOVE_IN_COSTS,
  PaymentCategory.ONE_TIME,
  PaymentCategory.OTHER,
  PaymentCategory.RENT,
  PaymentCategory.RENTAL_PROTECTION_DIRECT_DEBIT,
] as const;
